import React from 'react';
const templateCreators = {
    loadingIndicator: () => {
        return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 38 38", stroke: "#444" },
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("g", { transform: "translate(1 1)", strokeWidth: "2" },
                    React.createElement("circle", { strokeOpacity: ".5", cx: "18", cy: "18", r: "18" }),
                    React.createElement("path", { d: "M36 18c0-9.94-8.06-18-18-18" },
                        React.createElement("animateTransform", { attributeName: "transform", type: "rotate", from: "0 18 18", to: "360 18 18", dur: "1s", repeatCount: "indefinite" }))))));
    },
    submit: () => {
        return (React.createElement("svg", { width: "10", height: "10", viewBox: "0 0 40 40" },
            React.createElement("path", { d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z" })));
    },
};
const Template = (props) => {
    return (React.createElement(React.Fragment, null, templateCreators[props.template]()));
};
export default Template;
